import { render, staticRenderFns } from "./SayfaTanimla.vue?vue&type=template&id=54997aa3&scoped=true&"
import script from "./SayfaTanimla.vue?vue&type=script&lang=js&"
export * from "./SayfaTanimla.vue?vue&type=script&lang=js&"
import style0 from "./SayfaTanimla.vue?vue&type=style&index=0&id=54997aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54997aa3",
  null
  
)

export default component.exports